import React from "react";

import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CheckboxFieldBase } from "@/src/components/form-fields/CheckboxField";
import { FieldLegend, FieldSet } from "@/src/components/ui/field";

import { isRoleImplied, isRoleLocked, toggleRole } from "./adminRoleSelection";

import type { JSX } from "react";

import type { AdminRoleFormValues } from "./AdminRoleDialog.types";

interface AdminRoleCheckboxesProps {
  roleOptions: string[];
}

function AdminRoleCheckboxes({
  roleOptions,
}: AdminRoleCheckboxesProps): JSX.Element {
  const { t } = useTranslation("editor-users");
  const { control } = useFormContext<AdminRoleFormValues>();
  const { field } = useController({ control, name: "roles" });
  const selectedRoleList = field.value;

  const handleToggle = (role: string, checked: boolean): void => {
    field.onChange(toggleRole(selectedRoleList, role, checked));
  };

  return (
    <FieldSet className="gap-3">
      <FieldLegend variant="label">{t("roles")}</FieldLegend>
      {roleOptions.map((role) => (
        <CheckboxFieldBase
          key={role}
          disabled={isRoleLocked(role, selectedRoleList)}
          label={t(role)}
          onCheckedChange={(checked) => handleToggle(role, checked)}
          checked={
            selectedRoleList.includes(role) ||
            isRoleImplied(role, selectedRoleList)
          }
        />
      ))}
    </FieldSet>
  );
}

export default AdminRoleCheckboxes;
